import { render, staticRenderFns } from "./column-new-layout.vue?vue&type=template&id=2c2449f2&scoped=true"
import script from "./column-new-layout.vue?vue&type=script&lang=js"
export * from "./column-new-layout.vue?vue&type=script&lang=js"
import style0 from "./column-new-layout.vue?vue&type=style&index=0&id=2c2449f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2449f2",
  null
  
)

export default component.exports